import { BoundActions, createHook, HookFunction } from 'react-sweet-state';

import {
	ProjectSortEnum,
	GoalSortEnum,
	TimelineDateSpan,
	DirectoryViewUiType,
} from './__generated__/storeDirectoryView.graphql';
import { directoryViewStore } from './store';
import type { ActionsType, DirectoryViewDetails } from './types';

export const useDirectoryViewStore: HookFunction<
	DirectoryViewDetails,
	BoundActions<DirectoryViewDetails, ActionsType>,
	void
> = createHook(directoryViewStore);

export const useDirectoryViewSort: HookFunction<
	ProjectSortEnum[] | GoalSortEnum[] | undefined,
	BoundActions<DirectoryViewDetails, ActionsType>,
	void
> = createHook(directoryViewStore, {
	selector: (directoryView) =>
		directoryView.entityType === 'GOAL' ? directoryView.goalSort : directoryView.projectSort,
});

export const useDirectoryViewTimelineDateSpan: HookFunction<
	TimelineDateSpan | undefined,
	BoundActions<DirectoryViewDetails, ActionsType>,
	void
> = createHook(directoryViewStore, {
	selector: (directoryView) => directoryView.timelineDateSpan,
});

export const useDirectoryViewUiViewType: HookFunction<
	DirectoryViewUiType | undefined,
	BoundActions<DirectoryViewDetails, ActionsType>,
	void
> = createHook(directoryViewStore, {
	selector: (directoryView) => directoryView.uiViewType,
});

export const useDirectoryViewStoredTql: HookFunction<
	string | undefined,
	BoundActions<DirectoryViewDetails, ActionsType>,
	void
> = createHook(directoryViewStore, {
	selector: (directoryView) => directoryView.storedTql,
});

export const useDirectoryViewColumns: HookFunction<
	string[] | undefined,
	BoundActions<DirectoryViewDetails, ActionsType>,
	void
> = createHook(directoryViewStore, {
	selector: (directoryView) => directoryView.directoryViewColumns,
});

export const useDirectoryViewIsDefault: HookFunction<
	boolean,
	BoundActions<DirectoryViewDetails, ActionsType>,
	void
> = createHook(directoryViewStore, {
	selector: (directoryView) => directoryView.isDefault ?? false,
});
